import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { SnackbarService } from '../../../core/services/snackbar.service';
import {
  enqueueErrorSnackbar,
  enqueueInfoSnackbar,
  enqueueSuccessSnackbar,
  enqueueWarningSnackbar,
} from '../actions/enqueue-snackbar.actions';

@Injectable()
export class ShowNewSnackbarEffect {
  readonly #actions$ = inject(Actions);
  readonly #snackbarService = inject(SnackbarService);

  readonly enqueueSuccessSnackbar$ = createEffect(
    () => {
      return this.#actions$.pipe(
        ofType(enqueueSuccessSnackbar),
        switchMap(({ configuration }) =>
          this.#snackbarService.enqueueSnackbar({
            ...configuration,
            type: 'success',
          }),
        ),
      );
    },
    { dispatch: false },
  );

  readonly enqueueInfoSnackbar$ = createEffect(
    () => {
      return this.#actions$.pipe(
        ofType(enqueueInfoSnackbar),
        switchMap(({ configuration }) =>
          this.#snackbarService.enqueueSnackbar({
            ...configuration,
            type: 'info',
          }),
        ),
      );
    },
    { dispatch: false },
  );

  readonly enqueueWarningSnackbar$ = createEffect(
    () => {
      return this.#actions$.pipe(
        ofType(enqueueWarningSnackbar),
        switchMap(({ configuration }) =>
          this.#snackbarService.enqueueSnackbar({
            ...configuration,
            type: 'warning',
          }),
        ),
      );
    },
    { dispatch: false },
  );

  readonly enqueueErrorSnackbar$ = createEffect(
    () => {
      return this.#actions$.pipe(
        ofType(enqueueErrorSnackbar),
        switchMap(({ configuration }) =>
          this.#snackbarService.enqueueSnackbar({
            ...configuration,
            type: 'error',
          }),
        ),
      );
    },
    { dispatch: false },
  );
}
